<template>
	<div class="d-flex flex-1 h-100 overflow-hidden">
		<v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">Manage System Parameters</v-toolbar-title>
            </v-toolbar>
            <div>
				<v-card-title>
					<div class="border-top p-4 overflow-auto text-start" style="width: 600px;">
						<v-text-field solo v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
					</div>
					<div class="border-top p-4 flex-1 overflow-auto text-start">
						<v-btn @click="showAddDialog" width="200px" color="primary">Add System Parameter</v-btn>
					</div>
					<div class="border-top p-4  overflow-auto text-end" style="align-items: ;">
						<v-checkbox v-model="checked" label="Show System" ></v-checkbox>
					</div>
				</v-card-title>
			</div>
			<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px">
				<v-data-table :headers="headers" :items="filtereditems" :search="search" item-key="id" disable-sort hide-default-footer class="elevation-1"
					:items-per-page="filtereditems.length">
					<template v-slot:item="row">
						<tr>
							<td>{{row.item.keyword }}</td>
							<td>{{row.item.description }}</td>
							<td>{{row.item.content }}</td>
							<td class="text-start">
								<div class="onhover-display">
									<div class="custom-icon-wrapper">
										<v-icon small @click="editItem(row.item)">custom-icon white-bg edit-icon</v-icon>
									</div>
									<div class="custom-icon-wrapper">
										<v-icon small @click="openDeleteDialog(row.item)">custom-icon white-bg delete-icon</v-icon>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
		<v-dialog v-model="addDialogVisible" max-width="500px" >
			<v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
						<span v-if="editedItem.id">Edit System Parameter</span>
                        <span v-else>Add System Parameter</span></v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addDialogVisible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                   <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<v-row>
							<v-col cols="12">
								<v-label>Keyword *</v-label>
								<v-text-field solo v-model="editedItem.keyword"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-label>Description *</v-label>
								<v-text-field solo v-model="editedItem.description"></v-text-field>
							</v-col>
							<v-col cols="12">
								<v-label>Content *</v-label>
								<v-text-field solo v-model="editedItem.content" ></v-text-field>
							</v-col>
							<v-col cols="3">
								<v-checkbox  v-model="editedItem.isSystem" label="Is System" ></v-checkbox>
							</v-col>
						</v-row>
					</div>
					<v-card-actions class="gap-2 sticky-actions">
						<v-spacer></v-spacer>
						<v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelAddDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn class="primary" style="min-width: 100px !important;" @click="upsertItem()">{{ $t("res_ButtonText_Continue") }}</v-btn>
					</v-card-actions>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios";
import constants from "@/assets/js/constants.js";
import router from '@/router/index.js'

export default {
	data() {
		return {
			headers: [
				{ text: "Keyword", value: "keyword", align: "start", width: "30%" },
				{ text: "Description", value: "description", align: "start", width: "30%" },
				{ text: "Content", value: "content", align: "start", width: "30%" },
				{ text: "Actions", value: "actions", align: "start", width: "10%" },
			],
			items: [],
			search: "",
			checked: false,
			addDialogVisible: false,
			displayedItems: [],
			isCheckedsystem:false,
			editedItem: {
				id: null,
				keyword: "",
				description: "",
				content: "",
				isSystem:false,
			},
		};
	},
	methods: {
		backToAdminPage()
		{
            router.push({ name: 'admin' })
        },
		async fetchData() 
		{
			const res = await axios
				.get(constants.baseApiUrl + "Admin/GetSystemParameter")
				.then((res) => {
					this.items = res.data;
					this.displayedItems = res.data;
				})
				.catch((error) => console.error("Error fetching data:", error));
		},
		showAddDialog() 
		{
			this.addDialogVisible = true
			this.editedItem = { keyword:"", description: "", content: "", isSystem:false, }
		},
		editItem(item) 
		{
			this.editedItem = item
			this.addDialogVisible = true
		},
		async upsertItem()
		{
			if (this.editedItem.keyword.trim() == "" || this.editedItem.description.trim() == "" ||this.editedItem.content.trim() == "") 
			{
				window.showAlert('res_Msgs_FillRequired', 'warning')
				return
			}
			if (this.editedItem.id == null)
			{
				var SystemParameterObj = { id: 0, keyword: this.editedItem.keyword,description: this.editedItem.description, 
					content:this.editedItem.content,isSystem:this.editedItem.isSystem}

				await axios.post(constants.baseApiUrl + "Admin/AddSystemParameter", SystemParameterObj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error creating item:", err));
			}
			else
			{
				var SystemParameterObj = { id: this.editedItem.id, keyword: this.editedItem.keyword, description:this.editedItem.description,
					 content: this.editedItem.content,isSystem:this.editedItem.isSystem }

				await axios.post(constants.baseApiUrl + "Admin/UpdateSystemParameter", SystemParameterObj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error Updating item:", err));
			}
		},
		cancelAddDialog() 
		{
			this.addDialogVisible = false
			this.editedItem.id = 0
			this.editedItem.keyword = ""
			this.editedItem.description = ""
			this.editedItem.content = ""
			this.editedItem.isSystem=false,
			this.fetchData()
		},
		openDeleteDialog(item) 
		{
            window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
                () => 
				{
					axios.get(constants.baseApiUrl + "Admin/DeleteSystemParameter?id=" + item.id)
						.then((res) => this.fetchData())
						.catch((err) => console.log(err));
                },
                () => { })
		},
	},
	mounted() 
	{
		this.fetchData();
	},
	watch: 
	{
		searchTerm(newTerm) 
		{
			if (newTerm === "") 
			{
				this.displayedItems = this.items;
			} 
			else 
			{
				const search = newTerm.toLowerCase();
				this.displayedItems =
					this.items.filter((item) => item.keyword.toLowerCase().includes(search)) +
					this.items.filter((item) => item.description.toLowerCase().includes(search)) +
					this.items.filter((item) => item.content.toLowerCase().includes(search));
			}
		},
	},
	computed:
	{
        filtereditems()
		{
			if (this.checked)
				return this.displayedItems = this.items.filter((item)=>item.isSystem===true);
			else
				return this.displayedItems = this.items.filter((item) => item.isSystem === false);
		},
	},
};
</script>

<style scoped>
	.v-card__title{align-items: normal;}
</style>